export default __webpack_public_path__ + "static/media/error-no-content.148a27d8.svg";